module.exports = __webpack_public_path__ + "static/media/tire-rugged.9d53e102.svg";